export const MISSING_TOKEN_ERROR_MSG = "Missing access token. Request blocked.";

/** Paged list for /api/rcdata/getdata (server defaults: limit=2000, max=10000). */
export const RC_DATA_GETDATA_URL = "/api/rcdata/getdata?limit=2000&offset=0";
